export const adminRoutes = {
  path: "admin",
  meta: { requiresAuth: true },
  component: () => import("./Main"),
  children: [
    // { path: "", component: () => import("./cashregisters/MyBox") },
    { path: "entitys", component: () => import("./entitys/Index") },
    { path: "areas", component: () => import("./areas/Index") },
    { path: "employees", component: () => import("./employees/Index") },
    { path: "sources", component: () => import("./sources/Index") },
    { path: "reasons", component: () => import("./reasons/Index") },
    {
      path: "cashregisters",
      component: () => import("./cashregisters/Index.vue"),
      name: "admin-cash-registers"
    },
    {
      path: "my-cashregister",
      component: () => import("./cashregisters/MyBox")
    },
    {
      path: "reports/finantial",
      component: () => import("./reports/Finantial")
    },
    {
      path: "reports/results-daily",
      component: () => import("./reports/ResultsDaily")
    },
    {
      path: "reports/liquidations",
      component: () => import("./reports/Liquidations")
    },
    {
      path: "reports/entitys",
      component: () => import("./reports/ReportEntitys")
    },
    {
      path: "cashregisters/:cashRegisterId",
      component: () => import("./cashregisters/Box.vue"),
      name: "adm.cash-register-show",
      props: true
    },
    { path: "liquidations", component: () => import("./liquidations/Index") },
    {
      path: "settings",
      component: () => import("./settings/SettingsPage.vue"),
    },
    {
      component: () => import("./menus/MenuListView.vue"),
      path: "menus",
    },
    {
      name: "admin.menu-create",
      component: () => import("./menus/MenuFormView.vue"),
      path: "menus/create",
    },
    {
      name: "admin.menu-edit",
      component: () => import("./menus/MenuFormView.vue"),
      path: "menus/:id",
      props: true
    },
    {
      name: "admin.user-list",
      component: () => import("./users/UserListView.vue"),
      path: "users"
    },
    {
      name: "admin.user-permissions",
      component: () => import("./users/UserPermissionView.vue"),
      path: "users/:id/permissions",
      props: true
    },
    {
      name: "admin.role-create",
      component: () => import("./permissions/RoleCreateView.vue"),
      path: "roles/create",
    },
    {
      name: "admin.role-edit",
      component: () => import("./permissions/RoleFormView.vue"),
      path: "roles/:id",
      props: true
    },
    {
      name: "admin.role-list",
      component: () => import("./permissions/RoleListView.vue"),
      path: "roles",
    },
    {
      name: "admin.permission-list",
      component: () => import("./permissions/PermissionListView.vue"),
      path: "permissions",
    },
    {
      name: "admin.permission-create",
      component: () => import("./permissions/PermissionCreateView.vue"),
      path: "permissions/create",
    },
    {
      name: "admin.permission-edit",
      component: () => import("./permissions/PermissionFormView.vue"),
      path: "permissions/:id",
      props: true
    }
  ]
};
